import { useTranslation } from 'react-i18next';
import { UploadOutlined, InboxOutlined, EyeTwoTone, EyeInvisibleOutlined, DeleteOutlined } from '@ant-design/icons';
import { useEffect, useRef, useState } from 'react';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { InputNumber } from '@app/components/common/inputs/InputNumber/InputNumber';
import { BaseSelect, Option } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseSwitch } from '@app/components/common/BaseSwitch/BaseSwitch';
import { BaseRadio } from '@app/components/common/BaseRadio/BaseRadio';
import { BaseSlider } from '@app/components/common/BaseSlider/BaseSlider';
import { BaseUpload } from '@app/components/common/BaseUpload/BaseUpload';
import { BaseRate } from '@app/components/common/BaseRate/BaseRate';
import { notificationController } from '@app/controllers/notificationController';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseCheckbox } from '@app/components/common/BaseCheckbox/BaseCheckbox';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import config from '@app/config';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { updateProductAction, getProductByIdAction, getAllCategoriesAction, getAllVariantAction } from '@app/store/slices/userSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { returnArea } from '@app/utils/utils';
import { Collapse, Form, Popconfirm, Row, Upload } from 'antd';
import { InputPassword } from '@app/components/common/inputs/InputPassword/InputPassword.styles';
const { Panel } = Collapse;

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};



export const ValidationFormProductEdit: React.FC<any> = (props) => {
  const formRef = useRef<any>();
  const [isFieldsChanged, setFieldsChanged] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [fileIdDocs, setFileIdDocs] = useState(null);
  const [categories, setAllCategories] = useState([]);
  const [fileId, setFileId] = useState(null);
  const [formReset, setFormReset] = useState(false);
  const [variants, setAllVariants] = useState([]);
  const [isVariantEnabled, setVariantEnabled] = useState<boolean>(false);
  const [variantDetails, setVariantDetails] = useState([]); // Track variant details dynamically

  const { id } = useParams();

  useEffect(() => {
    if (!isVariantEnabled) setVariantDetails([]);
  }, [isVariantEnabled])


  useEffect(() => {

    dispatch(getAllCategoriesAction()).unwrap().then((resp) => {

      if (resp) {
        setAllCategories(resp.data);
      }


    }).catch((err: any) => {
      notificationController.error({ message: err.message });
    })
    dispatch(getAllVariantAction())
      .unwrap()
      .then((resp) => {
        if (resp) setAllVariants(resp.data);
      })
      .catch((err: any) => notificationController.error({ message: err.message }));


    dispatch(getProductByIdAction(String(id))).unwrap().then((resp) => {
      let _resp = resp?.data;
      if (_resp) {

        if (_resp.photo) setFileId(_resp?.photo?._id);
        let arr: any[] = [];

        if (_resp && _resp.photo) {
          let x = _resp.photo;
          arr = [{ name: x.originalName, status: 'done', url: config.API1Url + '/' + x.filePath, uid: x._id }];
        }
        _resp.photo = arr;
        setVariantEnabled(_resp?.isVariantEnabled);
        setFormData(_resp);

        setVariantDetails(_resp?.variants || []);
        setLoading(false);
      }


    }).catch((err: any) => {
      notificationController.error({ message: err.message });
    })

  }, [])






  const onFinish = async (values: any) => {
    if (isVariantEnabled && variantDetails.length === 0) {
      notificationController.warning({ message: 'You enabled variants but did not choose any' });
      return;
    }


    // Validate sale price and regular price for non-variant products
    if (!isVariantEnabled && values.regular_price &&  parseFloat(values.sale_price) > parseFloat(values.regular_price)) {
      notificationController.warning({ message: "Sale price cannot be greater than regular price" });
      return;
    }



    setLoading(true);


    setFieldsChanged(false);



    console.log(values);
    values.photo = fileId;
    values.id = id;
    values.variants = isVariantEnabled ? variantDetails : []; // Attach variant details to the payload
    dispatch(updateProductAction(values))
      .unwrap()
      .then((resp: any) => {
        setLoading(false);
        if (resp._id) {
          notificationController.success({ message: t('common.success') });

          navigate('/admin/products/list');
        }
        else {
          notificationController.error({ message: 'Failed to save product' });
        }

      }).catch((err: any) => {
        setLoading(false);
        notificationController.error({ message: err.message });
      })


  };

  const normFile = (e: any) => {
    console.log({ e })
    if (e.file.status == 'done') {
      console.log('e.file?.response?.file?._id', e.file?.response?.file?._id);
      setFileId(e.file?.response?.file?._id);
    }
    if (Array.isArray(e.fileList)) {
      return e.fileList;
    }

    return e && e.fileList;
  };



  const beforeUpload = (file: any, fileList: any[]) => {

    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    if (!isJPG) {

      notificationController.warning({ message: "only .jpg, .jpeg, .png file types are allowed" });
      return Upload.LIST_IGNORE;
    }

    if (file.size > 5e+6) {
      notificationController.warning({ message: `Max Size Supported is 5 MB` });
      return Upload.LIST_IGNORE;
    }
    return true;

  }
  const handleAddVariantOption = (variantId: string, selectedOptions: any[]) => {
    if (variantDetails && variantDetails.length >= 1) {
      notificationController.warning({ message: "Only one variant allowed per product" });
      return;
    }
    const newOptions = selectedOptions.map((option) => ({
      quantity: option.split(' ')[0],
      unit: option.split(' ')[1],
      sale_price: '',
      regular_price: '',
      quantityAvailable: '',
    }));

    setVariantDetails((prev) => [
      ...prev,
      { variant_id: variantId, options: newOptions },
    ]);
  };

  const handleRemoveOption = (variantIndex: number, optionIndex: number) => {
    const updatedVariants = [...variantDetails];
    updatedVariants[variantIndex].options = updatedVariants[variantIndex].options.filter(
      (_, idx) => idx !== optionIndex
    );

    // Remove the variant completely if no options remain
    if (updatedVariants[variantIndex].options.length === 0) {
      updatedVariants.splice(variantIndex, 1);
    }

    setVariantDetails(updatedVariants);
  };
  const handleOptionFieldChange = (variantIndex: number, optionIndex: number, field: string, value: string) => {
    const updatedVariants = [...variantDetails];
    updatedVariants[variantIndex].options[optionIndex][field] = value;

    // Validate sale price and regular price
    if (field === 'sale_price' || field === 'regular_price') {
      const salePrice = updatedVariants[variantIndex].options[optionIndex].sale_price;
      const regularPrice = updatedVariants[variantIndex].options[optionIndex].regular_price;

      if (parseFloat(salePrice) > parseFloat(regularPrice)) {
        notificationController.warning({ message: "Sale price cannot be greater than regular price" });
        return;
      }
    }

    setVariantDetails(updatedVariants);
  };
  const handleRemoveVariant = () => {
    setVariantDetails([]);
    notificationController.info({ message: "Variant removed successfully" });
  };


  console.log('variantDetails--variantDetails--variantDetails', variantDetails);
  return (
    <>

      {!isLoading &&
        <Form {...formItemLayout} ref={formRef} name="addProductForm" onFinish={onFinish}
          initialValues={formData}>

          <BaseRow gutter={[10, 10]}>
            <BaseCol xs={24} sm={12} >
              <BaseButtonsForm.Item
                name="name"
                label={"Name"}
                rules={[{ required: true, message: "Name is required" }]}
              >
                <BaseInput />
              </BaseButtonsForm.Item>
            </BaseCol>

            {!isVariantEnabled &&
              <>



                <BaseCol xs={24} sm={12} >
                  <BaseButtonsForm.Item
                    name="regular_price"
                    label={"Regular Price"}
                    rules={[{ required: true, message: "Regular Price is required" }]}
                  >
                    <BaseInput type='number' min={1} />
                  </BaseButtonsForm.Item>
                </BaseCol>
                <BaseCol xs={24} sm={12} >
                  <BaseButtonsForm.Item
                    name="sale_price"
                    label={"Sale Price"}
                    rules={[
                      { required: true, message: "Sale Price is required" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (parseFloat(value) > parseFloat(getFieldValue('regular_price'))) {
                            return Promise.reject(new Error('Sale price cannot be greater than regular price'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <BaseInput type='number' min={1} />
                  </BaseButtonsForm.Item>
                </BaseCol>


              </>
            }

            <BaseCol xs={24} sm={12} >
              <BaseButtonsForm.Item
                name="category"
                label={"Category"}
                rules={[{ required: true, message: "Category is required" }]}
              >
                <BaseSelect placeholder={"Please select a category"}>
                  {categories && Array.isArray(categories) && categories.filter(x=>x.isActive).map((item: any) =>

                    <Option value={item?._id}>{item?.name}</Option>

                  )}

                </BaseSelect>
              </BaseButtonsForm.Item>
            </BaseCol>

            <BaseCol xs={24} sm={12} md={12} >
              <BaseButtonsForm.Item
                name="photo"
                label={"Upload a photo"}
                valuePropName="fileList"
                rules={[
                  {
                    required: true,
                    message: "Please select a photo"
                  }
                ]}
                getValueFromEvent={normFile}
              >
                <BaseUpload beforeUpload={beforeUpload} name="file" action={config.API1Url + '/api/files/upload'} listType="picture" multiple={false} maxCount={1}>
                  <BaseButton type="default" icon={<UploadOutlined />}>
                    {t('forms.validationFormLabels.clickToUpload')}
                  </BaseButton>
                </BaseUpload>
              </BaseButtonsForm.Item>
            </BaseCol>


            {!isVariantEnabled &&
              <> <BaseCol xs={24} sm={12} >
                <BaseButtonsForm.Item
                  name="quantity"
                  label={"Quantity (Size)"}
                  rules={[{ required: true, message: "Quantity is required" }]}
                >
                  <BaseInput placeholder='litre | mg | small-medium-large' type='number' />
                </BaseButtonsForm.Item>
              </BaseCol>

                <BaseCol xs={24} sm={12} >
                  <BaseButtonsForm.Item
                    name="unit"
                    label={"unit"}
                    rules={[{ required: true, message: "Unit is required" }]}
                  >
                    <BaseInput placeholder='litre | mg' />
                  </BaseButtonsForm.Item>
                </BaseCol>

                <BaseCol xs={24} sm={12} >
                  <BaseButtonsForm.Item
                    name="quantityAvailable"
                    label={"Quantity Available"}
                    rules={[{ required: true, message: "Quantity Available is required" }]}
                  >
                    <BaseInput type='number' min={1} />
                  </BaseButtonsForm.Item>
                </BaseCol>


                <BaseCol xs={24} sm={12} >
                  <BaseButtonsForm.Item
                    name="calories"
                    label={"Calories"}
                    rules={[{ required: true, message: "Calories is required" }]}
                  >
                    <BaseInput type='number' min={0} />
                  </BaseButtonsForm.Item>
                </BaseCol>


                <BaseCol xs={24} sm={12} >
                  <BaseButtonsForm.Item
                    name="protein"
                    label={"Protein"}
                    rules={[{ required: true, message: "Protein is required" }]}
                  >
                    <BaseInput type='number' min={0} />
                  </BaseButtonsForm.Item>
                </BaseCol>

              </>
            }
            <BaseCol xs={24} sm={12} >
              <BaseButtonsForm.Item
                name="description"
                label={"Description"}
                rules={[{ required: true, message: "Description is required" }]}
              >
                <BaseInput.TextArea rows={5} />
              </BaseButtonsForm.Item>
            </BaseCol>




            {!props.outer && <BaseCol xs={24} sm={12} md={8} >
              <BaseButtonsForm.Item name="isActive" label="Status" valuePropName="checked">
                <BaseSwitch />
              </BaseButtonsForm.Item>


            </BaseCol>
            }
          </BaseRow>

          <BaseRow gutter={[10, 10]}>
            <BaseCol xs={24}>
              <BaseButtonsForm.Item name="isVariantEnabled" valuePropName="checked" label="Enable Variants">
                <BaseSwitch checked={isVariantEnabled} onChange={(checked) => setVariantEnabled(checked)} />
              </BaseButtonsForm.Item>
            </BaseCol>
          </BaseRow>

          {isVariantEnabled && (
            <BaseRow gutter={[10, 10]}>
              <BaseCol xs={24}>
                <BaseSelect
                  placeholder="Select Variant"
                  onChange={(variantId) => {
                    const selectedVariant = variants.find((variant) => variant._id === variantId);
                    const options = selectedVariant.values.map((value: any) => `${value.quantity} ${value.unit}`);
                    handleAddVariantOption(variantId, options);
                  }}
                >
                  {variants.map((variant: any) => (
                    <Option key={variant?._id} value={variant?._id}>
                      {variant?.name}
                    </Option>
                  ))}
                </BaseSelect>
              </BaseCol>
            </BaseRow>
          )}

          {isVariantEnabled && variantDetails.map((variant, variantIndex) => (

            <>
              <Row gutter={[10, 10]}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: '10px 0px' }}>
                  <span style={{ marginTop: '10px' }}>Variant Name: {variant?.variant_id?.name}</span>
                  <BaseButton type="primary" onClick={handleRemoveVariant} danger icon={<DeleteOutlined />}>
                    Remove
                  </BaseButton>
                </div>
              </Row>
              <Collapse
                key={variant.variant_id}
                activeKey={variant?.options.map((_, index) => index)}
                onChange={(keys) => setActiveKeys(keys)}
                style={{ marginTop: "20px" }}
              >
                {variant.options.map((option, optionIndex) => (
                  <Panel key={optionIndex} header={`${option.quantity} ${option.unit}`}>
                    <BaseRow gutter={[10, 10]}>
                      <BaseCol xs={24} sm={8}>
                        <Form.Item
                          label="Regular Price"
                          name={["variants", variantIndex, "options", optionIndex, "regular_price"]}
                          rules={[{ required: true, message: "Regular Price is required" }]}
                        >
                          <BaseInput
                            placeholder="Regular Price"
                            value={option.regular_price}
                            onChange={(e) =>
                              handleOptionFieldChange(variantIndex, optionIndex, "regular_price", e.target.value)
                            }
                          />
                        </Form.Item>
                      </BaseCol>

                      <BaseCol xs={24} sm={8}>
                        <Form.Item
                          label="Sale Price"
                          name={["variants", variantIndex, "options", optionIndex, "sale_price"]}
                          rules={[{ required: true, message: "Sale Price is required" }]}
                        >
                          <BaseInput
                            placeholder="Sale Price"
                            value={option.sale_price}
                            onChange={(e) =>
                              handleOptionFieldChange(variantIndex, optionIndex, "sale_price", e.target.value)
                            }
                          />
                        </Form.Item>
                      </BaseCol>

                      <BaseCol xs={24} sm={8}>
                        <Form.Item
                          label="Quantity Available"
                          name={["variants", variantIndex, "options", optionIndex, "quantityAvailable"]}
                          rules={[{ required: true, message: "Quantity Available is required" }]}
                        >
                          <BaseInput
                            placeholder="Quantity Available"
                            value={option.quantityAvailable}
                            onChange={(e) =>
                              handleOptionFieldChange(variantIndex, optionIndex, "quantityAvailable", e.target.value)
                            }
                          />
                        </Form.Item>
                      </BaseCol>

                      <BaseCol xs={24} sm={8}>
                        <Form.Item
                          label="Calories"
                          name={["variants", variantIndex, "options", optionIndex, "calories"]}
                          rules={[{ required: true, message: "Calories is required" }]}
                        >
                          <BaseInput
                            placeholder="Calories"
                            value={option.calories}
                            onChange={(e) =>
                              handleOptionFieldChange(variantIndex, optionIndex, "calories", e.target.value)
                            }
                          />
                        </Form.Item>
                      </BaseCol>

                      <BaseCol xs={24} sm={8}>
                        <Form.Item
                          label="Protein"
                          name={["variants", variantIndex, "options", optionIndex, "protein"]}
                          rules={[{ required: true, message: "Protein is required" }]}
                        >
                          <BaseInput
                            placeholder="Protein"
                            value={option.protein}
                            onChange={(e) =>
                              handleOptionFieldChange(variantIndex, optionIndex, "protein", e.target.value)
                            }
                          />
                        </Form.Item>
                      </BaseCol>

                      <BaseCol xs={24}>
                        <Popconfirm
                          title="Are you sure you want to remove this option?"
                          onConfirm={() => handleRemoveOption(variantIndex, optionIndex)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <BaseButton danger icon={<DeleteOutlined />}>
                            Remove
                          </BaseButton>
                        </Popconfirm>
                      </BaseCol>
                    </BaseRow>
                  </Panel>
                ))}
              </Collapse>
            </>
          ))}

          <BaseRow gutter={[10, 10]}>
            <BaseCol xs={24}>
              <BaseButtonsForm.Item>
                <BaseButton type="primary" htmlType="submit" loading={isLoading}>
                  {t('common.submit')}
                </BaseButton>
              </BaseButtonsForm.Item>
            </BaseCol>
          </BaseRow>
        </Form>
      }
    </>
  );
};
